export const enum AccountType {
    NUORDER = "nuorder",
    BRAND = "brand",
    BUYER = "buyer",
}
